/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { ClrAlertModule } from "./alert/alert.module";
var ClrEmphasisModule = (function () {
    function ClrEmphasisModule() {
    }
    return ClrEmphasisModule;
}());
export { ClrEmphasisModule };
ClrEmphasisModule.decorators = [
    { type: NgModule, args: [{
                exports: [
                    ClrAlertModule
                ]
            },] },
];
/** @nocollapse */
ClrEmphasisModule.ctorParameters = function () { return []; };
//# sourceMappingURL=emphasis.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/emphasis/emphasis.module.js
// module id = 182
// module chunks = 4